import { render, staticRenderFns } from "./QuizzesItem.vue?vue&type=template&id=10c9d91d&scoped=true&"
import script from "./QuizzesItem.vue?vue&type=script&lang=js&"
export * from "./QuizzesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c9d91d",
  null
  
)

export default component.exports